import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { VsFormComponent } from '@app/widget/vs-form/vs-form.component';
import { VsGridComponent } from '@app/widget/vs-grid/vs-grid.component';
import { SftpDashboardDetailHandler } from '@custom/modules/gen/sftptrackerdashboard/sftpdashboard-detail/sftpdashboard-detail.handler';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe, formatDate } from '@angular/common';


import { ApiConstants } from '@app/api-constants';
import { AppGlobalService } from '@app/app-global.service';
import { EllipsisService } from '@app/ellipsis.service';
import { ModalPopupService } from '@app/shared/services/modal-popup.service';
import { NotificationService } from '@app/shared/services/notification.service';
import { AppConstants } from '@custom/core/app-constants';
import { CustomService } from '@custom/services/custom.service';
import SecurityJson from '@app/security/changelog/changelog.security';
@Component({
  selector: 'app-sftpdashboard-detail',
  templateUrl: './sftpdashboard-detail.component.html',
  styleUrls: ['./sftpdashboard-detail.component.scss']
})
export class SftpdashboardDetailComponent extends SftpDashboardDetailHandler implements OnInit,AfterViewInit {
  @ViewChild(VsFormComponent) child;
  public data = {};
  private dtTable: any;
  public formConfig: any;
  @ViewChild(VsGridComponent)
  private gridComp: any = VsGridComponent;
  public gridConfig: any = {};
  private isPrototyping: boolean;
  local: any = {};
  public pageName = 'SFTP_TRACKER_DASHBOARD';
  today: Date = new Date();
  public heightInt : any;

  filter: {};
  refreshGridMethod: () => void;

  dataChanged = (data) => {
    
  };
  public hasWorkflow = false;

  constructor(
    public appGlobal: AppGlobalService,
    public customService: CustomService,
    public element: ElementRef,
    public ellipsis: EllipsisService,
    public notification: NotificationService,
    public modalPopupService: ModalPopupService,
    public translate:TranslateService,
    private datePipe: DatePipe
  ) {
super(translate)
  }

  public onBeforeOnInit() {
    this.filter = {};
  }

  ngOnInit(): void {
    this.onBeforeOnInit();
    
    this.gridConfig = this.loadGridConfig();
    this.isPrototyping = false;
    this.formConfig = this.getFormConfig(SecurityJson);

  }
  ngAfterViewInit() {
    this.heightInt = setInterval(() => {
      const setHeight = document.getElementsByClassName('dataTables_scrollBody');
      if (setHeight && setHeight.length > 0) {
        const firstElement = setHeight[0] as HTMLElement;
        if (firstElement) {
          firstElement.style.height = 'auto';
          clearInterval(this.heightInt);
        }
      }
    }, 100);
    this.child.form.value.date=new Date();
  }

  private getFormConfig(securityJson: any) {
    this.local.formConfig = {};
    const today = new Date();
    const defaultDate = today.toISOString().substring(0, 10);

    this.local.formConfig.date = {
      security_code: 'date',
      label: 'SFTP Export Date',
      type: 'date',
      name: 'exportDate123',
      placeholder: '',
      infoBubble: '',
      values: [],
      options: [],
      disabled: false,
      toolbar: true,
      displayonly: false,
      validations: {
      },
      formAttributes: {
        change: this.searchdata.bind(this),
      },
    };
    return {
      initCallback: this.changeLogFormInitComplete.bind(this),
      collapsible: false,
      submit: 'saveBasicDetails',
      class: 'no-margin form-elements-group',
      securityEvaluation: this.hasWorkflow,
      staticSecurityJson: securityJson,
      disabledForm: false,
      columns: 100,
      groups: [
        {
          groupHeaderClass: 'form-group-subheader hidden',
          groupContentClass: 'paddingZero',
          collapsible: 'false',
          columns: '100',
          label: '',
          disableRights: false,
          columnsWidth: 10,
          items: [
            {
              groupHeaderClass: 'form-group-subheader hidden',
              groupContentClass: 'paddingZero',
              collapsible: 'false',
              columns: '25',
              label: '',
              disableRights: false,
              columnsWidth: 10,
              items: [
                this.local.formConfig.date,
              ]
            },
      
          ]
        }
      ]
    };

  }

  private createRefresh(settings: any, json: any, dtTable: any) {
    this.refreshGridMethod = () => {
      this.gridComp.refreshGrid();
    };
  }

  public searchdata() {
    this.refreshGridMethod();
  }

  private loadGridConfig(): any {
    const self = this;

    const gridConfig: any = {
      autoWidth: false,
      ordering: false,
      customOrdering: false,
      columnDefs: [
        {
          "defaultContent": "",
          "targets": "_all"
        }
      ],
      columns: [
        {
          data: 'triggerEvent', name: 'trigger_event', title: 'Trigger ID', type: 'string', width: '7%'
        },
        { data: 'created_date_time', name: 'created_date_time', width: '13%', title: 'Created Date', type: 'date' },
        {
          data: 'aft_Total_YES', name: 'aft_Total_YES', title: 'Total AFT Yes count', type: 'number', width: '12%'
        },
        {
          data: 'sft_Total_YES', name: 'sft_Total_YES', title: 'Total SFT Yes count', width: '12%', type: 'number'
        },
        {
          data: 'aft_users', name: 'aft_users', title: 'Total AFT user count', width: '10%', type: 'number'
        },
        {
          data: 'sft_users', name: 'sft_users', title: 'Total SFT user count', width: '10%', type: 'number'
        },
        {
          data: 'status', name: 'status', title: 'Status', type: 'string', width: '36%',conditionalColorField: 'status',
          conditionalColor: {
            'Exported to SFTP': 'status-status-exported-to-sftp',
            'Exported to Drive': 'status-status-exported-to-drive',
            'Error': 'status-status-error',
            'Error In SFT File Generation': 'status-status-error',
            'Error In SFT File validation': 'status-status-error',
            'Error In SFT File Transfer': 'status-status-error',
            'Exported to SFTP But Error in AFT File Generation': 'status-status-error',
            'In progress': 'status-status-in-progress'
          }
        }
      ],
      searchMandatory: true,
      emptyTableMsg: "Please search by filters to get data",
      infoEmpty: "No matching results, please try a different search",
      disableSelection: true,
      onRowSelect: (selectedRows: any, id: any) => {
      },
      onRowDeselect: (selectedRows: any) => {
      },
      onInitComplete: (dtTable: any, settings: any, json: any) => {
        self.dtTable = dtTable;
        self.createRefresh(settings, json, dtTable);
        //setTimeout(() => {
        self.setGridHeight(settings, json, dtTable);
        //}, 1000);
      },
      fnServerParams: (searchObj) => {
        return this.extendFnServerParams(searchObj);
      },
      onBeforeGridServiceRequest: (params: any, isFromSort: boolean, isFromRefresh: boolean) => {
      },
      onAfterGridServiceResponse: (params: any, isFromSort: boolean, isFromRefresh: boolean, data: any) => {
      },
      onRowCreate: (row: any, data: any, dataIndex: any) => {
      },
      onRowClick: (event: any, id: any) => {

      },
      drawCallback: (settings: any) => {
      },
      headerCallback: (thead: any, data: any, start: any, end: any, display: any) => {
      },
      preDrawCallback: (settings: any) => {
      },
      rowCallback: (row: any, data: any, index: any) => {
      },
      maxRowsAllowedForSelection: AppConstants.maxRowsAllowedToSelect,
      rowMenuOptions: [
      ],
      beforeRowMenuShow: (option: any, data: any, row: any) => {
      },
      onRowMenuClick: (option: any, row: any, data: any) => {
      },
      onMobileRowDisplay: (row: Node, data: any[] | object, index: number) => {
        return row;
      },
      complexHeader: [
      ]
    };


    gridConfig.scrollY = self.getGridHeight();

    if (this.isPrototyping) {
      gridConfig.method = 'get';
      gridConfig.ajaxUrl = '/assets/data/SftpDashboard.json'
    } else {
      gridConfig.ajaxMethod = 'POST';
      gridConfig.ajaxUrl = '/' + AppConstants.apihost + '/' + ApiConstants.getSftpDashboard.url;
    }

    return gridConfig;
  }

  private getGridHeight() {
    const currentEl = this.element.nativeElement;
    const gridEl = currentEl.querySelector('app-vs-grid');
    const gridElOffsetTop = gridEl.querySelector('div').offsetTop + (AppConstants.isMobile ? 40 : 90);
    let gridHeight = window.innerHeight - gridElOffsetTop;
    return gridHeight;
  }

  private setGridHeight(settings: any, json: any, dtTable: any) {
    const gridHeight = this.getGridHeight();
    $(settings.nScrollBody).css({ height: gridHeight + 'px', 'max-height': gridHeight + 'px' });
  }

  public handleCustomEvents(e: Event, form?: any) { }

  public changeLogFormInitComplete(form: any) {
  }

  public extendFnServerParams(searchObj) {
    if (Object.keys(this.filter).length > 0) {
      $.extend(searchObj, this.filter);
    }

    if (this.child != null && this.child.form != null && this.child.form.value) {

      if (!this.child.form.value.exportDate123) {
        this.child.form.value.exportDate123 = '';
      }
      
      searchObj =
      {
        'date': this.getFormattedDate(this.child.form.value.exportDate123),
        
      }
    }
    //TODO -  pass filter data in search
    return searchObj;
  }

  private zeroPadding = (num, places) => String(num).padStart(places, '0');

  public getFormattedDate(data: any) {
    if(!data) {
      return data;
    }

    const date = new Date(data);

    if (date.toLocaleDateString() != 'Invalid Date') {
      return date.getFullYear() + '-' + this.zeroPadding(date.getMonth() + 1, 2) + '-' + this.zeroPadding(date.getDate(),2);
    }

    if(date.toLocaleDateString() != 'Invalid Date') {
      return date.toISOString().split('T')[0]
    }
    
    return null;
  }
}
